//handles different displays for data snapshot fields
// export enum SignatureMode {
//   WetSignature = 0, //requires wet signature (basic user)
//   VerifiedSingleSigner = 1, //VSS - Verified Single Signer
//   VerifiedMultiSigner = 2, //VMS - Verified Multi Signer
// }

import { Lookup } from './lookup.interface';
export interface SignatureModeLookup extends Lookup {
  verifiedUser?: boolean; //configurable option to require signers to be using a verified account
  verifiedMultiSigner?: boolean;
  verifiedSingleSigner?: boolean;
}

export type SignatureModeOption = 'wetSignature' | 'verifiedSingleSigner' | 'verifiedMultiSigner';

export const SignatureMode: Record<SignatureModeOption, SignatureModeLookup> = {
  wetSignature: {
    code: 'wetSignature',
    displayValue: 'Wet Signature',
    verifiedUser: false,
    verifiedMultiSigner: false,
    verifiedSingleSigner: false,
  },
  verifiedSingleSigner: {
    code: 'verifiedSingleSigner',
    displayValue: 'Verified Single Signer',
    verifiedUser: true,
    verifiedMultiSigner: false,
    verifiedSingleSigner: true,
  },
  verifiedMultiSigner: {
    code: 'verifiedMultiSigner',
    displayValue: 'Verified Multi Signer',
    verifiedUser: true,
    verifiedMultiSigner: true,
    verifiedSingleSigner: false,
  },
};
